/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default {
  SET_LEADERBOARDS (state, leaderboards) {
    state.leaderboards = leaderboards
  },
  SET_SCAVENGERHUNT (state, scavengerHunt) {
    state.scavengerHunt = scavengerHunt
  }
}
